import { AdgroupFormData, CampaignFormData, REGION_ID } from '@tt4b/ttam-enums';
import { StateEnum, useStdAdgroupIs, useStdObjectiveType, useStore } from '@tt4b/ttam-hooks';
import { computed, Ref } from '@vue/composition-api';

export function usePlatformIs(opt: { adgroupData: Ref<AdgroupFormData>; campaignData: Ref<CampaignFormData> }) {
  const { isLeadAds, isBrandAuction, isEngagement } = useStdObjectiveType({ campaignFormData: opt.campaignData });
  const { isWebsite, isOnlyHelo, isHasTopbuzzOnly } = useStdAdgroupIs({
    adgroupFormData: opt.adgroupData,
    campaignFormData: opt.campaignData,
  });
  const { state } = useStore();
  const areaMap = computed(() => state[StateEnum.areaData].data.value.areaMap);
  const platformVisible = computed(
    () => isWebsite.value || isBrandAuction.value || isLeadAds.value || isEngagement.value
  );
  /** TBNR 的TW, BR, ID, KR 不支持 iOS */
  const tbnrAreas = [REGION_ID.KOREA, REGION_ID.INDONESIA, REGION_ID.BRAZIL, REGION_ID.TAIWAN];
  const countryIds = computed(() =>
    opt.adgroupData.value.particleLocations.filter(item => areaMap.value[item]?.level === 1)
  );
  const isTBNRDisabledIOS = computed(() => countryIds.value?.some(item => tbnrAreas.includes(item)));
  const iOSPlatformDisabled = computed(
    // HELO 不支持 iOS 定向
    () =>
      (isOnlyHelo.value && (isWebsite.value || isLeadAds.value)) ||
      (isHasTopbuzzOnly.value && (isWebsite.value || isLeadAds.value) && isTBNRDisabledIOS.value)
  );

  return {
    platformVisible,
    iOSPlatformDisabled,
  };
}
